import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  border-top: 1px solid #ececec;
`;